import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgLocalVelos = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>{`.prestation_cls_fill{fill:${color}`}</style>
		</defs>
		<path
			className="prestation_cls_fill"
			d="M319.07 175.64c-11.61 0-22.55 2.9-32.15 7.99l-16.06-25.7V121.8h21.25c7.67 0 13.91 6.24 13.91 13.91s-6.24 13.91-13.91 13.91v10.05c13.21 0 23.95-10.74 23.95-23.95s-10.74-23.95-23.95-23.95h-31.29v42.59h-96.43v-21.29h-24.44v-6.81c0-2.45 1.99-4.44 4.44-4.44h33.9c7.67 0 13.91 6.24 13.91 13.91h10.05c0-13.21-10.74-23.95-23.95-23.95h-33.9c-7.99 0-14.49 6.5-14.49 14.49v16.85h24.44v14.83l-16.06 25.7a68.498 68.498 0 0 0-32.15-7.99c-37.99 0-68.91 30.91-68.91 68.91s30.91 68.91 68.91 68.91 68.91-30.91 68.91-68.91c0-22.8-11.13-43.03-28.24-55.58l12.09-19.34 29.69 59.38c-4.37 3.77-7.15 9.33-7.15 15.54 0 11.32 9.21 20.54 20.54 20.54s20.54-9.21 20.54-20.54c0-4.89-1.72-9.37-4.58-12.9l47.55-63.4 12.95 20.72c-17.11 12.55-28.24 32.79-28.24 55.58 0 37.99 30.91 68.91 68.91 68.91s68.91-30.91 68.91-68.91-30.91-68.91-68.91-68.91Zm-154.09 68.91c0 32.46-26.4 58.86-58.86 58.86s-58.86-26.4-58.86-58.86 26.4-58.86 58.86-58.86c9.65 0 18.76 2.35 26.81 6.49l-35.87 57.4h51.65v-10.05h-33.53l26.27-42.02c14.28 10.75 23.53 27.84 23.53 47.05Zm2.5-80.15h88.3l-45.91 61.21a20.339 20.339 0 0 0-7.93-1.59c-1.51 0-2.99.18-4.41.49l-30.05-60.11Zm34.46 90.65c-5.78 0-10.49-4.71-10.49-10.49s4.71-10.49 10.49-10.49 10.49 4.71 10.49 10.49-4.71 10.49-10.49 10.49Zm117.12 48.37c-32.46 0-58.86-26.4-58.86-58.86 0-19.21 9.25-36.3 23.53-47.05l31.07 49.71 8.52-5.32-31.07-49.71a58.452 58.452 0 0 1 26.81-6.49c32.46 0 58.86 26.4 58.86 58.86s-26.4 58.86-58.86 58.86Z"
		/>
	</svg>
)
export default SvgLocalVelos
